module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1504-8a47f04c916b1e2fd7289a5bd0e5fe59.png";